import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_slsodr_to_slsinv_consol_run_hdr_slsinv_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  consol_run_hdr_guid: fromDatatype.GuidDataFieldInterface;
  slsinv_hdr_guid: fromDatatype.GuidDataFieldInterface;
  slsinv_line_guid: fromDatatype.GuidDataFieldInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_slsodr_to_slsinv_consol_run_hdr_slsinv_link_RowClass
  implements bl_fi_slsodr_to_slsinv_consol_run_hdr_slsinv_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  consol_run_hdr_guid: fromDatatype.GuidDataFieldInterface;
  slsinv_hdr_guid: fromDatatype.GuidDataFieldInterface;
  slsinv_line_guid: fromDatatype.GuidDataFieldInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
